/**
 * @file ria main
 * @author Chestnut
 */

import Vue from 'vue';
import router from './router';
import GlobalModel from './views/GlobalModel';
import configManager from 'veui/managers/config';
import AppView from './views/AppView';

export default class Ria {
    config = {};

    AppComponent = AppView;

    constants = {};

    globalModel = null;

    routerInstance = null;

    app = null;

    container = '#app';

    /**
     * 构造器
     *
     * @constructor
     * @param {Object} config 配置
     * @param {Object} constants 常量
     * @param {*} AppComponent 渲染的app组件
     */
    constructor(config, constants, AppComponent) {
        if (config) {
            this.config = config;
        }

        if (constants) {
            this.constants = constants;
        }

        if (AppComponent) {
            this.AppComponent = AppComponent;
        }
    }

    /**
     * 启动应用
     *
     * @public
     */
    start() {
        this.initGlobalModel();
        this.initRouter();
        this.initUI();
        this.initApp();
    }

    /**
     * 初始化全局 model
     *
     * @protected
     */
    initGlobalModel() {
        this.globalModel = new GlobalModel();
        this.globalModel.activeNmpHook(this.config.hooks);
    }

    /**
     * 初始化路由
     *
     * @protected
     */
    initRouter() {
        this.routerInstance = router.init(this.config.routes);
        this.globalModel.init(this.config, this.constants, this.routerInstance);
    }

    /**
     * 初始化 veui 相关内容
     *
     * @protected
     */
    initUI() {
        configManager.set({
            'datepicker.shortcuts': [
                {
                    label: '最近3天',
                    from: -2,
                    to: 0
                },
                {
                    label: '最近7天',
                    from: -6,
                    to: 0
                },
                {
                    label: '本周',
                    from: {
                        startOf: 'week',
                        days: 0
                    },
                    to: 0
                },
                {
                    label: '本月',
                    from: {
                        startOf: 'month'
                    },
                    to: 0
                },
                {
                    label: '默认',
                    from: -30,
                    to: 0
                }
            ]
        });
    }

    /**
     * 初始化应用
     *
     * @protected
     */
    initApp() {
        const AppComponent = this.AppComponent;
        this.app = new Vue({
            el: this.container,
            router: this.routerInstance,
            provide: {
                global: this.globalModel
            },
            render(createElement) {
                return createElement(AppComponent);
            }
        });
    }
}
